/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RfqTransactionDetailItem } from '../../models/rfq-transaction-detail-item';

export interface ApiVendorRfqImportItemPost$Params {

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
}

export function apiVendorRfqImportItemPost(http: HttpClient, rootUrl: string, params?: ApiVendorRfqImportItemPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RfqTransactionDetailItem>>> {
  const rb = new RequestBuilder(rootUrl, apiVendorRfqImportItemPost.PATH, 'post');
  if (params) {
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RfqTransactionDetailItem>>;
    })
  );
}

apiVendorRfqImportItemPost.PATH = '/api/vendor/rfq/ImportItem';
